
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 5a1 1 0 011-1h22a1 1 0 110 2H1a1 1 0 01-1-1zM0 12a1 1 0 011-1h22a1 1 0 110 2H1a1 1 0 01-1-1zM0 19a1 1 0 011-1h22a1 1 0 110 2H1a1 1 0 01-1-1z","fill":"#9AA0B5"}})])
          )
        }
      }
    